import React from "react";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div style={{ marginTop: "50px", height: "100%" }}>
      <h1 className="center fof">404</h1>
      <p className="center nf">Not Found</p>
    </div>
  );
}
